<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body" id="hall-event-container">
                <!--{{model}}-->
                <div class="row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold required" :for="'schedulerTitle' + _uid">
                            {{$t('scheduler.title')}}
                        </label>
                        <input type="text"
                               class="form-control"
                               v-model="model.title"
                               v-validate="'required'"
                               :data-vv-as="$t('scheduler.title')"
                               :name="'schedulerTitle' + _uid"
                               :id="'schedulerTitle' + _uid"/>
                        <span class="text-danger" v-if="errors.has('schedulerTitle' + _uid)">{{ errors.first('schedulerTitle' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'schedulerDescription' + _uid">
                            {{$t('scheduler.description')}}
                        </label>
                        <input type="text"
                               class="form-control"
                               v-model="model.description"
                               :name="'schedulerDescription' + _uid"
                               :id="'schedulerDescription' + _uid"/>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <!-- <kendo-datasource ref="eventsDatasource"
                                          :transport="transportSettings.eventsTransportSettings"
                                          :server-filtering="true"
                                          :server-paging="true"
                                          :schema-model-id="'registerEntryId'"
                                          :schema-model-fields="schemaModels.eventsSchemaModel"
                                          :error="dataSourceError"
                                          :requestEnd="datasorceRequestEnd"
                                          :typeof="'odata-v4'">
                        </kendo-datasource> -->

                        <label :for="'task-event' + _uid" class="col-form-label font-weight-bold">
                            {{$t('scheduler.gridHeaders.eventName')}}
                        </label>
                        <!-- {{ model.eventIdStr }}
                        {{ model.eventName }} -->
                        <dropdown-search
                            type="EventRegister"
                            :searchMinLength="0"
                            v-model="model.eventIdStr"
                            v-validate="'required'"
                            :data-vv-as="$t('scheduler.gridHeaders.eventName')"
                            :name="'task-event' + _uid"
                            :id="'task-event' + _uid"
                            :popup="popup"
                            @input="onEventInput"
                        />
                        <span class="text-danger" v-if="errors.has('task-event' + _uid)">{{ errors.first('task-event' + _uid) }}</span>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="form-row align-items-center">
                            <div class="col-auto my-1">
                                <div>
                                    <input type="checkbox" id="mapVenueToEventCheck"
                                           v-model="model.mapVenueToEvent"
                                           @change="mapVenueToEventChange($event)">
                                    <label class="font-weight-bold" for="mapVenueToEventCheck">
                                        {{ $t('scheduler.mapVenueToEventCheck') }}
                                    </label>
                                </div>
                                <div>
                                    <input type="checkbox" id="hideFromDescriptionCheck"
                                           v-model="model.hideFromDescription">
                                    <label class="font-weight-bold" for="hideFromDescriptionCheck">
                                        {{ $t('scheduler.hideFromDescription') }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-6 col-sm-12">
                                <kendo-datasource ref="venueDatasource"
                                                  :transport="transportSettings.venueTransportSettings"
                                                  :filter="venueFilter"
                                                  :server-filtering="true"
                                                  :server-paging="false"
                                                  :schema-total="'total'"
                                                  :schema-data="'data'"
                                                  :schema-model-id="'placeId'"
                                                  :schema-model-fields="schemaModels.venueSchemaModel"
                                                  :error="logDataSourceError"
                                                  :requestEnd="datasorceRequestEnd">
                                </kendo-datasource>

                                <label class="col-form-label font-weight-bold" :for="'venue' + _uid">
                                    {{$t('scheduler.venue')}}
                                </label>
                                <kendo-multicolumncombobox ref="venueDropdown"
                                                           :data-source-ref="'venueDatasource'"
                                                           :data-text-field="'name'"
                                                           :data-value-field="'placeId'"
                                                           :popup="popup"
                                                           :name="'venue' + _uid"
                                                           :id="'venue' + _uid"
                                                           v-validate="'required'"
                                                           :data-vv-as="$t('scheduler.venue')"
                                                           :clear-button="true"
                                                           v-model="model.placeIdStr"
                                                           :placeholder="$t('choose')"
                                                           :no-data-template="$t('missingData')"
                                                           :filter="'contains'"
                                                           style="width:100%"
                                                           aria-describedby="venueHelpBlock">
                                    <kendo-multicolumncombobox-column :field="'name'"
                                                                      :title="$t('editor.common.name')"
                                                                      :width="250">
                                    </kendo-multicolumncombobox-column>

                                </kendo-multicolumncombobox>
                                <small id="venueHelpBlock" class="form-text text-muted">
                                    {{ $t('scheduler.venueHelpBlock') }}
                                </small>
                                <span class="text-danger" v-if="errors.has('venue' + _uid)">{{ errors.first('venue' + _uid) }}</span>
                            </div>

                            <div class="form-group col-md-6 col-sm-12">
                                <kendo-datasource ref="hallDatasource"
                                                  :transport="transportSettings.hallTransportSettings"
                                                  :server-filtering="false"
                                                  :server-paging="false"
                                                  :schema-model-id="'hallId'"
                                                  :schema-model-fields="schemaModels.hallSchemaModel"
                                                  :error="logDataSourceError"
                                                  :requestEnd="datasorceRequestEnd"
                                                  :typeof="'odata-v4'">
                                </kendo-datasource>

                                <label class="col-form-label font-weight-bold" :for="'hall' + _uid">
                                    {{$t('scheduler.hall')}}
                                </label>
                                <kendo-multicolumncombobox ref="hallDropdown"
                                                           :data-source-ref="'hallDatasource'"
                                                           :auto-bind="false"
                                                           :cascade-from="'venue' + _uid"
                                                           :data-text-field="'name'"
                                                           :data-value-field="'hallId'"
                                                           :popup="popup"
                                                           :name="'hall' + _uid"
                                                           :id="'hall' + _uid"
                                                           v-validate="'required'"
                                                           :data-vv-as="$t('scheduler.hall')"
                                                           :clear-button="true"
                                                           v-model="model.hallIdStr"
                                                           :placeholder="$t('choose')"
                                                           :no-data-template="$t('missingData')"
                                                           :filter="'contains'"
                                                           style="width:100%"
                                                           aria-describedby="hallHelpBlock">
                                    <kendo-multicolumncombobox-column :field="'name'"
                                                                      :title="$t('editor.common.name')"
                                                                      :width="250">
                                    </kendo-multicolumncombobox-column>
                                    <kendo-multicolumncombobox-column :field="'capacity'"
                                                                      :title="$t('scheduler.capacity')"
                                                                      :width="150">
                                    </kendo-multicolumncombobox-column>

                                </kendo-multicolumncombobox>
                                <small id="hallHelpBlock" class="form-text text-muted">
                                    {{ $t('scheduler.hallHelpBlock') }}
                                </small>
                                <span class="text-danger" v-if="errors.has('hall' + _uid)">{{ errors.first('hall' + _uid) }}</span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-auto my-1">
                                <div>
                                    <input type="checkbox" id="isAllDay"
                                           v-model="model.isAllDay">
                                    <label class="font-weight-bold" for="isAllDay">
                                        {{$t('scheduler.isAllDay') }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group" v-if="!model.isAllDay">
                            <DateTimeRange :required="!model.isAllDay"
                                           :startTime.sync="model.startTime"
                                           :endTime.sync="model.endTime"
                                           :use-utc-time="true"
                                           :showTime="true"
                                           :min="dateMinValue"
                                           :max="dateMaxValue"
                                           :startTitle="'scheduler.gridHeaders.startDate'"
                                           :endTitle="'scheduler.gridHeaders.endDate'">
                            </DateTimeRange>
                        </div>
                        <div class="form-group" v-else>
                            <DateRange :required="model.isAllDay"
                                       :startTime.sync="model.startTime"
                                       :endTime.sync="model.endTime"
                                       :showTime="false"
                                       :min="dateMinValue"
                                       :max="dateMaxValue"
                                       :startTitle="'scheduler.gridHeaders.startDate'"
                                       :endTitle="'scheduler.gridHeaders.endDate'">
                            </DateRange>
                        </div>
                        <span class="text-danger"
                              v-if="isOutOfDateRange">{{ $t('notifications.invalidDateTimeRange') }}</span>
                        <div class="row align-items-center">
                            <div class="col-auto my-1">
                                <div>
                                    <input type="checkbox" id="saveAnyway"
                                           v-model="saveAnyway">
                                    <label class="font-weight-bold" for="saveAnyway">
                                        {{$t('scheduler.saveAnyway') }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!--<div class="row align-items-center">
                            <div class="col-auto my-1">
                                <div class="custom-control custom-checkbox mr-sm-2">
                                    <input type="checkbox" class="custom-control-input" id="limitTimeRange"
                                           v-model="limitTimeRange">
                                    <label class="custom-control-label font-weight-bold" for="limitTimeRange"> {{ $t('scheduler.isAllDay') }}</label>
                                </div>
                            </div>
                        </div>-->

                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-6 col-sm-12">
                        <label class="col-form-label font-weight-bold" for="lecturers">
                            {{$t('scheduler.lecturers')}}
                        </label>
                        <kendo-datasource ref="lecturersDatasource"
                                          :transport="transportSettings.lecturersTransportSettings"
                                          :type="'odata-v4'"
                                          :server-filtering="true"
                                          :error="dataSourceError"
                                          :requestEnd="datasorceRequestEnd"
                                          :schema-model-id="'personId'"
                                          :schema-model-fields="schemaModels.participantSchemaModel"
                                          :filter="eventFilter">
                        </kendo-datasource>

                        <kendo-multiselect v-model="model.lecturersPersonIds"
                                           :data-source-ref="'lecturersDatasource'"
                                           :data-text-field="'fullName'"
                                           :data-value-field="'personId'"
                                           :popup="popup"
                                           :placeholder="$t('choose')"
                                           :no-data-template="$t('missingData')"
                                           :id="'lecturers'"
                                           :name="'lecturers' + _uid"
                                           aria-describedby="lecturersHelpBlock">
                        </kendo-multiselect>
                        <small id="lecturersHelpBlock" class="form-text text-muted">
                            {{ $t('scheduler.lecturersHelpBlock') }}
                        </small>
                    </div>

                    <div class="form-group col-md-6 col-sm-12">
                        <label class="col-form-label font-weight-bold" for="coordinators">
                            {{$t('scheduler.coordinators')}}
                        </label>
                        <kendo-datasource ref="coordinatorsDatasource"
                                          :transport="transportSettings.coordinatorsTransportSettings"
                                          :type="'odata-v4'"
                                          :server-filtering="true"
                                          :error="dataSourceError"
                                          :requestEnd="datasorceRequestEnd"
                                          :schema-model-id="'personId'"
                                          :schema-model-fields="schemaModels.participantSchemaModel"
                                          :filter="eventFilter">
                        </kendo-datasource>

                        <kendo-multiselect v-model="model.coordinatorsPersonIds"
                                           :data-source-ref="'coordinatorsDatasource'"
                                           :data-text-field="'fullName'"
                                           :data-value-field="'personId'"
                                           :popup="popup"
                                           :placeholder="$t('choose')"
                                           :no-data-template="$t('missingData')"
                                           :id="'coordinators'"
                                           :name="'coordinators' + _uid"
                                           aria-describedby="coordinatorsHelpBlock">
                        </kendo-multiselect>
                        <small id="coordinatorsHelpBlock" class="form-text text-muted">
                            {{ $t('scheduler.coordinatorsHelpBlock') }}
                        </small>
                    </div>
                </div>
            </div>

            <div class="card-footer text-right m-2" v-if="!hideBtns">
                <div class="btn-group" role="group" aria-label="Hall event edit buttons">
                    <button v-if="allowSave && canCreateOrUpdateAgenda" type="button" class="btn btn-success"
                            @click.stop="onSave">
                        <i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}
                    </button>
                    <button v-if="allowDelete && canDeleteAgenda && !isNew" type="button" class="btn btn-danger"
                            @click.stop="onDelete">
                        <i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}
                    </button>
                    <button type="button" class="btn btn-danger" @click.stop="onCancel">
                        <i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventDetails, ScheduleTask } from '@/models/models';
    import { EventClaims, NomenclatureParentBySort } from '@/models/enums';
    import DateTimeRange from '@/components/dateTimeRange/DateTimeRange';
    import DateRange from '@/components/dateTimeRange/DateRange';
    import DropdownSearch from './../dropdown/DropdownSearch';
    import agendaService from '@/services/agenda.service';

    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: ScheduleTask,
                required: false
            },
            eventDetails: {
                type: EventDetails,
                required: false
            },
            create: {
                type: Boolean,
                default: false
            },
            hideBtns: {
                type: Boolean,
                default: false
            },
            allowSave: {
                type: Boolean,
                default: false
            },
            allowDelete: {
                type: Boolean,
                default: false
            }
        },
        components: {
            DateTimeRange,
            DateRange,
            DropdownSearch
        },
        data() {
            return {
                model: this.value,
                limitTimeRange: true,
                dateMinValue: '',
                dateMaxValue: '',
                isLoading: true,
                saveAnyway: false,
                eventRegisterSort: NomenclatureParentBySort.EventRegister,
                popup: {
                    appendTo: $("#hall-event-container")
                },
                transportSettings: {
                    eventsTransportSettings: {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/dynamicRegisters/eventsWithFieldCodes`,
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.odata4ParameterMap
                    },
                    mappedVenueTransportSettings: {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/hallScheduler/placeDropdownModelsForEvents`,
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.odata4ParameterMap
                    },
                    venueTransportSettings: {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/hallScheduler/placeDropdownModelsWithEventInfo/`,
                            dataType: 'json',
                            type: 'POST',
                            contentType: 'application/json',
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.venueParameterMap
                    },
                    hallTransportSettings: {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/hallScheduler/hallDropdownModels`,
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.odata4ParameterMap
                    },
                    lecturersTransportSettings: {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/hallScheduler/lecturers`,
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.odata4ParameterMap
                    },
                    coordinatorsTransportSettings: {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/hallScheduler/coordinators`,
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.odata4ParameterMap
                    }
                },
                schemaModels: {
                    eventsSchemaModel: {
                        registerEntryId: {
                            name: 'registerEntryId',
                            from: 'registerEntryId',
                            type: 'number',
                            nullable: false
                        },
                        eventName: { name: 'eventName', from: 'eventName', type: 'string', nullable: true },
                        displayName: { name: 'displayName', from: 'displayName', type: 'string', nullable: true },
                        eventStartDate: { name: 'eventStartDate', from: 'eventStartDate', type: 'date', nullable: true },
                        eventEndDate: { name: 'eventEndDate', from: 'eventEndDate', type: 'date', nullable: true },
                    },
                    venueSchemaModel: {
                        registerEntryId: {
                            name: 'registerEntryId',
                            from: 'registerEntryId',
                            type: 'number',
                            nullable: true
                        },
                        placeId: { name: 'placeId', from: 'placeId', type: 'number', nullable: true },
                        name: { name: 'name', from: 'name', type: 'string', nullable: false },
                    },
                    hallSchemaModel: {
                        hallId: { name: 'hallId', from: 'hallId', type: 'number', nullable: false },
                        placeId: { name: 'placeId', from: 'placeId', type: 'number', nullable: true },
                        name: { name: 'name', from: 'name', type: 'string', nullable: true },
                        capacity: { name: 'capacity', from: 'capacity', type: 'number', nullable: true },
                    },
                    participantSchemaModel: {
                        personId: { name: 'personId', from: 'personId', type: 'number', nullable: false },
                        registerEntryId: {
                            name: 'registerEntryId',
                            from: 'registerEntityId',
                            type: 'number',
                            nullable: false
                        },
                        fullName: { name: 'fullName', from: 'fullName', type: 'string', nullable: true }
                    }
                }
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            datasorceRequestEnd(e) {
                if (e.type === "read" && e.response) {

                }
            },
            logDataSourceError(e) {
                console.log(e);
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            odata4ParameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    let newOptions = kendo.data.transports["odata-v4"].parameterMap(options, operation);

                    return newOptions;
                }
            },
            venueParameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    if (!this.model.mapVenueToEvent) {
                        options.filter = null;
                    }

                    let val = Number(this.model.eventIdStr);
                    if (!isNaN(val) && val > 0) {
                        options.logic = "and";
                        options.filters = [
                            {
                                field: 'RegisterEntryId',
                                operator: 'eq',
                                value: val
                            }]
                    } else {
                        options.logic = "and";
                        options.filters = [
                            {
                                field: 'RegisterEntryId',
                                operator: 'eq',
                                value: -1
                            }]
                    }
                    let newOptions = { request: options, eventId: val };
                    return kendo.stringify(newOptions);
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    return kendo.stringify(options);
                }
            },
            onEventInput(e, item) {
                if (!item) {
                    this.model.eventName = '';
                } else {
                    let eventName = item.addData
                    if (eventName) {
                        this.model.eventName = eventName
                    }
                }

                if (this.model.mapVenueToEvent) {
                    this.resetVenueAndPlaceDropdowns()
                }
            },
            resetVenueAndPlaceDropdowns() {
                const venueDropdown = this.$refs.venueDropdown;
                const hallDropdown = this.$refs.hallDropdown;

                if (venueDropdown) {
                    venueDropdown.kendoWidget().text('')
                    venueDropdown.kendoWidget().trigger('change')
                }

                if (hallDropdown) {
                    hallDropdown.kendoWidget().text('')
                    hallDropdown.kendoWidget().trigger('change')
                }

                this.model.placeId = '';
                this.model.placeIdStr = '';
                this.model.hallId = '';
                this.model.hallIdStr = '';
            },
            mapVenueToEventChange(e) {
                if (e.target.checked === true) {
                    this.resetVenueAndPlaceDropdowns();
                }

                const dt = this.$refs.venueDatasource.kendoWidget();
                if (dt) {
                    dt.read();
                }
            },
            onCancel() {
                this.$emit("cancel");
            },
            onSave() {
                if (!this.canCreateOrUpdateAgenda) {
                    return this.$router.push(`/unauthorized`);
                }
                if (this.isOutOfDateRange && !this.saveAnyway) {
                    let msg = this.$t('notifications.outOfRange');
                    kendo.alert(msg);
                    return;
                }
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.doSave();
                    }
                });
            },
            onDelete() {
                if (!this.canDeleteAgenda) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('scheduler.deleteConfirm')} '${this.scheduleTask.title}'?`)
                    .then(function () {
                        this.doDelete();
                    }.bind(this));
            },
            doDelete() {
                agendaService
                    .delete(this.model.id)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("delete", this.model.id);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            doSave() {
                if (this.model.placeIdStr) {
                    this.model.placeId = Number(this.model.placeIdStr)
                }

                if (this.model.hallIdStr) {
                    this.model.hallId = Number(this.model.hallIdStr)
                }

                if (this.model.eventIdStr) {
                    this.model.eventId = Number(this.model.eventIdStr)
                }

                if (this.create && this.isNew) {
                    // Create
                    this.createAgenda();
                } else {
                    // Update
                    this.updateAgenda();
                }
            },
            createAgenda() {
                agendaService
                    .create(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.model.id = response.data.newHallEventId;
                        this.$emit("save", this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            updateAgenda() {
                agendaService
                    .update(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("save", this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            isNew() {
                let id = Number(this.model.id);
                return isNaN(id) || id <= 0;
            },
            canReadAgenda() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventAgenda];
                const canRead = this.$helpers.haveClaimReadRights(claim);
                return canRead || this.$store.getters.claims.agenda.read;
            },
            canCreateOrUpdateAgenda() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventAgenda];
                const canRead = this.$helpers.haveClaimCreateOrEditRights(claim);
                return canRead || this.$store.getters.claims.agenda.create;
            },
            canDeleteAgenda() {
                const claim = this.$store.getters.eventClaims[EventClaims.EventAgenda];
                const canRead = this.$helpers.haveClaimDeleteRights(claim);
                return canRead || this.$store.getters.claims.agenda.delete;
            },
            showMappedToEvent() {
                if (!this.model) {
                    return false;
                }

                return this.model.mapVenueToEvent === true;
            },
            eventFilter() {
                let val = Number(this.model.eventIdStr);
                if (!isNaN(val) && val > 0) {
                    return {
                        logic: "and",
                        filters: [
                            {
                                field: 'RegisterEntityId',
                                operator: 'eq',
                                value: val
                            }]
                    }
                }

                return {};
            },
            venueFilter() {
                if (!this.model.mapVenueToEvent) {
                    return null;
                }

                let val = Number(this.model.eventIdStr);
                if (!isNaN(val) && val > 0) {
                    return {
                        logic: "and",
                        filters: [
                        {
                            field: 'RegisterEntryId',
                            operator: 'eq',
                            value: val
                        }]
                    }
                } else {
                    return {
                        logic: "and",
                        filters: [
                        {
                            field: 'RegisterEntryId',
                            operator: 'eq',
                            value: -1 // show no venues
                        }]
                    }
                }
            },
            isOutOfDateRange() {
                if (this.model.startTime && this.eventDetails.eventStartDate
                    && this.model.endTime && this.eventDetails.eventEndDate) {
                    let curriculumStartDate = new Date(this.model.startTime);
                    let curriculumEndDate = new Date(this.model.endTime);
                    let eventStarDate = new Date(this.eventDetails.eventStartDate);
                    let eventEndDate = new Date(this.eventDetails.eventEndDate);

                    if (curriculumStartDate.getTime() < eventStarDate.getTime()
                        || curriculumStartDate.getTime() > eventEndDate.getTime()
                        || curriculumEndDate.getTime() > eventEndDate.getTime()
                        || curriculumEndDate.getTime() < eventStarDate.getTime()) {
                        return true;
                    } else {
                        return false;
                    }
                }

                return false;
            },
        },
        mounted() {
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new ScheduleTask(this.value);
                }
            },
            'model.mapVenueToEvent': function (val) {
                if (val) {
                    if (this.model.placeIdStr) {
                        this.model.placeIdStr = '';
                    }
                }
            },
            'model.isAllDay': {
                immediate: true,
                handler(newVal) {
                    if (newVal) {
                        if (this.model.startTime) {
                            this.model.startTime = new Date(this.model.startTime);
                            this.model.startTime.setHours(0, 0, 0);
                        }
                        if (this.model.endTime) {
                            this.model.endTime = new Date(this.model.endTime);
                            this.model.endTime.setHours(0, 0, 0);
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
